import instance from '../utils/instance';

class LoginService {
    async login(enterpriseName, username, password) {
        return await instance.post('crm/login/', {
            enterpriseName: enterpriseName,
            txtUsername: username,
            txtPassword: password
        });
    }
}

export default new LoginService();